import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingLicenses: false,
  loadingLicense: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingRevoke: false,
  loadingUpgrade: false,

  errorLoadingLicenses: null,
  errorLoadingLicense: null,
  errorCreating: null,
  errorUpdating: null,
  errorDeleting: null,
  errorRevoking: null,
  errorUpgrading: null,

  licenses: [],
  currentLicense: null,
  pagination: null,
  serverStatus: null,
};

export const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
    // Loadings
    setLoadingLicenses: (state) => {
      state.loadingLicenses = true;
      state.errorLoadingLicenses = null;
    },
    setLoadingLicense: (state) => {
      state.loadingLicense = true;
      state.errorLoadingLicense = null;
    },
    setLoadingCreate: (state) => {
      state.loadingCreate = true;
      state.errorCreating = null;
    },
    setLoadingUpdate: (state) => {
      state.loadingUpdate = true;
      state.errorUpdating = null;
    },
    setLoadingDelete: (state) => {
      state.loadingDelete = true;
      state.errorDeleting = null;
    },
    setLoadingRevoke: (state) => {
      state.loadingRevoke = true;
      state.errorRevoking = null;
    },
    setLoadingUpgrade: (state) => {
      state.loadingUpgrade = true;
      state.errorUpgrading = null;
    },

    // Errors
    setErrorLoadingLicenses: (state, { payload }) => {
      state.loadingLicenses = false;
      state.errorLoadingLicenses = payload;
    },
    setErrorLoadingLicense: (state, { payload }) => {
      state.loadingLicense = false;
      state.errorLoadingLicense = payload;
    },
    setErrorCreating: (state, { payload }) => {
      state.loadingCreate = false;
      state.errorCreating = payload;
    },
    setErrorUpdating: (state, { payload }) => {
      state.loadingUpdate = false;
      state.errorUpdating = payload;
    },
    setErrorDeleting: (state, { payload }) => {
      state.loadingDelete = false;
      state.errorDeleting = payload;
    },
    setErrorRevoking: (state, { payload }) => {
      state.loadingRevoke = false;
      state.errorRevoking = payload;
    },
    setErrorUpgrading: (state, { payload }) => {
      state.loadingUpgrade = false;
      state.errorUpgrading = payload;
    },

    // Data Sets
    setLicenses: (state, { payload: { content, pagination } }) => {
      state.loadingLicenses = false;
      state.licenses = content;
      state.pagination = pagination;
    },
    setCurrentLicense: (state, { payload }) => {
      state.loadingLicense = false;
      state.currentLicense = payload;
    },

    // Success Operations (for immediate UI updates)
    createLicenseSuccess: (state, { payload }) => {
      state.loadingCreate = false;
      state.licenses = [payload, ...state.licenses];
    },
    updateLicenseSuccess: (state, { payload }) => {
      state.loadingUpdate = false;
      state.loadingRevoke = false;
      state.loadingUpgrade = false;
      state.licenses = state.licenses.map((lic) =>
        lic.id === payload.id ? payload : lic,
      );
      if (state.currentLicense?.id === payload.id)
        state.currentLicense = payload;
    },
    deleteLicenseSuccess: (state, { payload: id }) => {
      state.loadingDelete = false;
      state.licenses = state.licenses.filter((lic) => lic.id !== id);
      if (state.currentLicense?.id === id) state.currentLicense = null;
    },

    setServerResponseStatus: (state, { payload }) => {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingLicenses,
  setLoadingLicense,
  setLoadingCreate,
  setLoadingUpdate,
  setLoadingDelete,
  setLoadingRevoke,
  setLoadingUpgrade,
  setErrorLoadingLicenses,
  setErrorLoadingLicense,
  setErrorCreating,
  setErrorUpdating,
  setErrorDeleting,
  setErrorRevoking,
  setErrorUpgrading,
  setLicenses,
  setCurrentLicense,
  createLicenseSuccess,
  updateLicenseSuccess,
  deleteLicenseSuccess,
  setServerResponseStatus,
} = licenseSlice.actions;

export default licenseSlice.reducer;
